export default __webpack_public_path__ + "static/media/empty-collection.eb1faa27.svg";